import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"play\">\n<path d=\"M5,22c-0.2,0-0.3,0-0.5-0.1C4.2,21.7,4,21.4,4,21V3c0-0.4,0.2-0.7,0.5-0.9c0.3-0.2,0.7-0.2,1,0l14,9\n\tc0.3,0.2,0.5,0.5,0.5,0.8s-0.2,0.7-0.5,0.8l-14,9C5.4,21.9,5.2,22,5,22z M6,4.8v14.3L17.2,12L6,4.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol